import {
  Badge,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "web-design-system";
import { AvatarEmployee } from "web-core";
import { getCORSSafeURL } from "@/utils/url";
import AppLogo from "../logo/app-logo";

type AccountDetailsDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  personName: string;
  isEmployeeRole: boolean;
  loginIdDisplay: string;
  employeePhone: string;
  employeeEmail: string;
  organizationLine: string;
  brandingLogo?: string | null;
  getInitials: (name: string) => string;
};

export function AccountDetailsDialog({
  open,
  onOpenChange,
  personName,
  isEmployeeRole,
  loginIdDisplay,
  employeePhone,
  employeeEmail,
  organizationLine,
  brandingLogo,
  getInitials,
}: AccountDetailsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg gap-0 overflow-hidden p-0">
        <DialogHeader className="p-6 pb-4">
          <DialogTitle className="!text-lg">Account Details</DialogTitle>
        </DialogHeader>
        <div className="p-7">
          <div className="mx-auto flex flex-col gap-8 px-8 py-4">
            <Card className="rounded-lg border-border/70 bg-muted">
              <CardContent className="flex flex-col gap-6 p-6 text-center">
                <div className="flex flex-col items-center gap-3">
                  <AvatarEmployee
                    size="default"
                    fallback={getInitials(personName)}
                  />
                  <span className="text-md font-semibold">{personName}</span>
                  <Badge
                    variant="custom"
                    className={
                      isEmployeeRole
                        ? "rounded-sm bg-tag-slate text-tag-slate-foreground"
                        : "rounded-sm bg-tag-violet text-tag-violet-foreground"
                    }
                  >
                    {isEmployeeRole ? "Employee" : "Admin"}
                  </Badge>
                </div>

                <div className="flex items-center justify-center gap-1">
                  <span className="text-md">Login ID: {loginIdDisplay}</span>
                </div>
                <div className="flex flex-col gap-2">
                  <span className="text-md text-muted-foreground">
                    Phone: {employeePhone}
                  </span>
                  <span className="text-md text-muted-foreground">
                    Email: {employeeEmail}
                  </span>
                </div>
              </CardContent>
            </Card>

            <Card className="rounded-lg border-border/70 bg-tag-slate">
              <CardContent className="py-4 px-6 text-left gap-3 flex flex-col">
                <p className="text-sm font-semibold text-muted-foreground">
                  Partner:
                </p>
                <div className="flex gap-4 items-center">
                  <div className="flex shrink-0 items-center justify-center overflow-hidden rounded-md">
                    {brandingLogo ? (
                      <img
                        crossOrigin="anonymous"
                        src={getCORSSafeURL(brandingLogo)}
                        alt=""
                        width={36}
                        height={36}
                        className="object-cover"
                      />
                    ) : (
                      <div className="flex items-center justify-center">
                        <AppLogo width={36} height={36} />
                      </div>
                    )}
                  </div>
                  <span className="line-clamp-2 text-left text-md font-semibold text-foreground">
                    {organizationLine}
                  </span>
                </div>
              </CardContent>
            </Card>
          </div>
          <DialogFooter className="flex-row justify-end pt-6">
            <Button type="button" onClick={() => onOpenChange(false)}>
              Done
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
